module.exports = __webpack_public_path__ + "img/bmcl_thumbnail.afd28aef.jpg";